import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import _isNull from "lodash/isNull";
import _isUndefined from "lodash/isUndefined";
import { AnyAction } from "redux";
import { CartState } from "../../../../../models/state";
import * as RETAILER_AT from "../../../retailer/state/actionTypes";
import * as VOUCHER_AT from "../../../voucher/state/actionTypes";
import { fulfilled } from "../../utils";
import * as AT from "../actionTypes";

const initialState: CartState = {
    content: [],
    isExpanded: false,
    activeSubscription: "",
    portingDates: {},
};

const reducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case AT.CHECKOUT_CART_IS_EXPANDED:
            return {
                ...state,
                isExpanded: action.payload.isExpanded,
            };
        case AT.CHECKOUT_CART_SET_ACTIVE_SUBSCRIPTION:
            return {
                ...state,
                activeSubscription: action.id,
            };
        case fulfilled(AT.CHECKOUT_ADD_ACCESSORY_TO_CART):
            if (_isEmpty(_get(action, "payload.cart.cart"))) {
                return state;
            }
            return {
                ...state,
                isExpanded: true,
                content: action.payload.cart.cart.content,
                bookStartTime: action.payload.cart.cart.bookStartTime,
                bookEndTime: action.payload.cart.cart.bookEndTime,
            };
        case fulfilled(AT.CHECKOUT_ADD_SERVICE_TO_CART):
        case fulfilled(AT.CHECKOUT_ADD_SUBSCRIPTION_IN_BUNDLE_TO_CART):
            if (_isEmpty(action.payload.cart)) {
                return state;
            }
            return {
                ...state,
                isExpanded: true,
                content: action.payload.cart.content,
                bookStartTime: action.payload.cart.bookStartTime,
                bookEndTime: action.payload.cart.bookEndTime,
            };
        case fulfilled(AT.CHECKOUT_REMOVE_SERVICE_FROM_CART):
        case fulfilled(AT.CHECKOUT_REMOVE_ITEM_BY_CART_ITEM_ID_FROM_CART):
        case fulfilled(AT.CHECKOUT_REMOVE_ONBOARDING_MOBILE_SUPPORT):
        case fulfilled(AT.CHECKOUT_REMOVE_MOBILE_REFUND_FROM_CART):
        case fulfilled(AT.CHECKOUT_ADD_ONBOARDING_MOBILE_SUPPORT):
        case fulfilled(AT.CHECKOUT_FETCH_CART):
        case fulfilled(AT.CHECKOUT_SET_SELECTED_PAYMENT_TYPE):
        case fulfilled(AT.CHECKOUT_SET_DELIVERY_TYPE):
        case fulfilled(VOUCHER_AT.VOUCHER_ADD):
        case fulfilled(VOUCHER_AT.VOUCHER_REMOVE):
        case fulfilled(AT.CHECKOUT_ADD_WEBDEAL_ACCESSORY_TO_CART):
        case fulfilled(AT.CHECKOUT_SET_MEMBER_DETAILS):
        case fulfilled(AT.CHECKOUT_CHECK_NEW_MEMBER_PHONE_NUMBER):
        case fulfilled(AT.CHECKOUT_CHECK_EXISTING_PHONE_NUMBER):
        case fulfilled(AT.CHECKOUT_RESET_ORDER):
        case fulfilled(AT.CHECKOUT_EMPTY_ORDER):
        case fulfilled(AT.CHECKOUT_EXTEND_ORDER):
        case fulfilled(AT.CHECKOUT_SET_PERSONAL_DETAILS):
        case fulfilled(AT.CHECKOUT_SET_MAIN_SUBSCRIPTION):
        case fulfilled(AT.CHECKOUT_RESET_MEMBER):
        case fulfilled(AT.CHECKOUT_REMOVE_SMART_DISCOUNT_FROM_HARDWARE_ITEM):
        case fulfilled(AT.CHECKOUT_ADD_EXTRA_SIM_TO_CART):
        case fulfilled(AT.CHECKOUT_APPLY_FLEXIBLE_LEASE):
        case fulfilled(AT.CHECKOUT_ADD_SUBSCRIPTION_TO_CART):
        case fulfilled(RETAILER_AT.RETAILER_SET_CUSTOMER_DETAILS):
        case fulfilled(RETAILER_AT.RETAILER_ADD_EXTERNAL_HARDWARE):
            if (_isEmpty(action.payload.cart)) {
                return state;
            }
            return {
                ...state,
                content: action.payload.cart.content,
                bookStartTime: action.payload.cart.bookStartTime,
                bookEndTime: action.payload.cart.bookEndTime,
            };
        case fulfilled(AT.CHECKOUT_REMOVE_ITEM_BY_ID_FROM_CART):
            if (_isEmpty(action.payload.cart)) {
                return state;
            }
            if (_isUndefined(action.payload.subscriptions) && !_isNull(action.payload.subscriptions)) {
                return {
                    ...state,
                    content: action.payload.cart.content,
                    bookStartTime: action.payload.cart.bookStartTime,
                    bookEndTime: action.payload.cart.bookEndTime,
                };
            }

            return {
                ...state,
                content: action.payload.cart.content,
                bookStartTime: action.payload.cart.bookStartTime,
                bookEndTime: action.payload.cart.bookEndTime,
                activeSubscription: Object.keys(action.payload.subscriptions).includes(state.activeSubscription || "")
                    ? state.activeSubscription
                    : undefined,
            };
        case fulfilled(AT.CHECKOUT_EMPTY_CART):
            return initialState;
        default:
            return state;
    }
};

export default reducer;
